const COMPLETED_STATUSES = ["Signed", "Completed In House", "Canceled"]
const DECLINED_STATUSES = ["Voided", "Boater Declined"]

export const UnsentActions = ({
  onSend,
  onRetry,
  onExpire,
  onCompleteInHouse,
  onBulkSend,
  canUpdate,
}) => [
  {
    label: "Edit",
    icon: "edit-square-md",
    href: (row) => row.editUrl,
    hidden: () => !canUpdate,
  },
  {
    label: "Retry",
    icon: "replay",
    onClickSingle: onRetry,
    hidden: (row) => row.status !== "Failed",
  },
  {
    label: "Send",
    icon: "send",
    onClickSingle: onSend,
    onClickBulk: onBulkSend,
    hidden: (row) => row.status === "Failed" || !canUpdate || !row.sendable,
    primary: true,
    confirm: {
      title: "Are you sure you want to send this quote?",
      message: () =>
        "This will send the quote to the boater so they can sign and pay. This cannot be undone.",
      confirmLabel: "Send",
    },
  },
  {
    label: "Complete in house",
    icon: "contract-circle-check",
    onClickSingle: onCompleteInHouse,
    hidden: (row) => !canUpdate || row.status === "Failed",
    confirm: {
      title: "Are you sure you want to complete this contract in house?",
      message: () =>
        "This will redirect you to the in-house completion flow and mark the contract as completed in house. This cannot be undone.",
      confirmLabel: "Complete in house",
    },
  },
  {
    label: "Void",
    icon: "contract-circle-x",
    danger: true,
    onClickSingle: onExpire,
    hidden: () => !canUpdate,
    confirm: {
      title: "Are you sure you want to void this contract?",
      message: () => "This will void the contract and cannot be undone.",
      confirmLabel: "Void",
    },
  },
  {
    label: "Contract PDF",
    icon: "document",
    href: (row) => row.generatePdfEndpoint,
    hidden: (row) => !canUpdate || row.status === "Failed",
  },
]

export const OutstandingActions = ({
  onResend,
  onRetry,
  onExpire,
  onMarkDeclined,
  onCompleteInHouse,
  onBulkResend,
  canUpdate,
}) => [
  {
    label: "Edit",
    icon: "edit-square-md",
    href: (row) => row.editUrl,
    hidden: () => !canUpdate,
  },
  {
    label: "Retry",
    icon: "replay",
    onClickSingle: onRetry,
    hidden: (row) => row.status !== "Failed",
  },
  {
    label: "Resend",
    icon: "send",
    primary: true,
    onClickSingle: onResend,
    onClickBulk: onBulkResend,
    hidden: (row) => row.status === "Failed" || !canUpdate || !row.sendable,
    confirm: {
      title: "Are you sure you want to send this quote?",
      message: () =>
        "This will send the quote to the boater so they can sign and pay. This cannot be undone.",
      confirmLabel: "Send",
    },
  },
  {
    label: "Contract PDF",
    icon: "document",
    href: (row) => row.generatePdfEndpoint,
    hidden: (row) => !canUpdate || row.status === "Failed",
  },
  {
    label: "Complete in house",
    icon: "contract-circle-check",
    onClickSingle: onCompleteInHouse,
    hidden: (row) => !canUpdate || row.status === "Failed",
    confirm: {
      title: "Are you sure you want to complete this contract in house?",
      message: () =>
        "This will redirect you to the in-house completion flow and mark the contract as completed in house. This cannot be undone.",
      confirmLabel: "Complete in house",
    },
  },
  {
    label: "Mark as declined",
    icon: "thumb-down",
    danger: true,
    confirm: {
      title: "Decline this contract?",
      message: (row) => `Are you sure you want to decline this contract?`,
      confirmLabel: "Yes, decline",
    },
    onClickSingle: onMarkDeclined,
    hidden: (row) => row.status === "Failed" || !canUpdate,
  },
  {
    label: "Void",
    icon: "contract-circle-x",
    danger: true,
    onClickSingle: onExpire,
    hidden: () => !canUpdate,
    confirm: {
      title: "Are you sure you want to void this contract?",
      message: () => "This will void the contract and cannot be undone.",
      confirmLabel: "Void",
    },
  },
]

export const CompletedActions = ({ onArchive }) => [
  {
    label: "View Contract",
    icon: "eye",
    iconStyle: "solid",
    role: "view",
    primary: true,
    href: (row) => row.contractUrl,
    hidden: (row) => !COMPLETED_STATUSES.includes(row.status),
  },
  {
    label: "Delete",
    danger: true,
    icon: "sf-trashcan",
    onClickSingle: onArchive,
    hidden: (row) => !DECLINED_STATUSES.includes(row.status),
    confirm: {
      title: "Are you sure you want to delete this contract?",
      message: () => "This will delete the contract. This cannot be undone.",
      confirmLabel: "Delete",
    },
  },
]
